import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import type { EdmSocialMediaDataFragment } from './EdmSocialMediaData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
import { EdmSocialMediaDataFragmentDoc } from './EdmSocialMediaData';
export type EdmEmailFooterPublicDataFragment = (
  { __typename: 'EdmEmailFooter' }
  & Pick<SchemaTypes.EdmEmailFooter, 'privacyPolicyUrl' | 'legalNoticeUrl'>
  & { connectText: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), disclaimerText: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), arrowIcon?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & UploadFileWithPreviewFormDataFragment
  )>, emailIcon?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & UploadFileWithPreviewFormDataFragment
  )>, phoneIcon?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & UploadFileWithPreviewFormDataFragment
  )>, copyRight: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), socialMedia: Array<(
    { __typename: 'EdmEmailSocialMedia' }
    & EdmSocialMediaDataFragment
  )> }
);

export const EdmEmailFooterPublicDataFragmentDoc = /*#__PURE__*/ gql`
    fragment EdmEmailFooterPublicData on EdmEmailFooter {
  connectText {
    ...TranslatedStringData
  }
  disclaimerText {
    ...TranslatedStringData
  }
  privacyPolicyUrl
  legalNoticeUrl
  arrowIcon {
    ...UploadFileWithPreviewFormData
  }
  emailIcon {
    ...UploadFileWithPreviewFormData
  }
  phoneIcon {
    ...UploadFileWithPreviewFormData
  }
  copyRight {
    ...TranslatedStringData
  }
  socialMedia {
    ...EdmSocialMediaData
  }
}
    `;